import { useCallback, useMemo, useState } from 'react';

import type { InvoiceQuerySchema } from '../schemas/invoices/invoice-query-schema';

export function useFocusedInvoice() {
  const [focusedInvoice, setFocusedInvoice] = useState<InvoiceQuerySchema | null>(null);

  const activeInvoiceId = useMemo(() => (focusedInvoice != null ? String(focusedInvoice.id) : null), [focusedInvoice]);

  const clearFocusedInvoice = useCallback(() => {
    setFocusedInvoice(null);
  }, []);

  return {
    focusedInvoice,
    activeInvoiceId,
    setFocusedInvoice,
    clearFocusedInvoice,
  };
}
